<script setup lang="ts">
import { Link, useForm } from "@inertiajs/vue3";

import Btn from "@/components/ui/atoms/Btn.vue";
import Input from "@/components/ui/atoms/Input.vue";
import Pill from "@/components/ui/atoms/Pill.vue";
import PillContainer from "@/components/ui/atoms/PillContainer.vue";
import { resolveUrl } from "@/utils/urls";

const form = useForm({
  username: null,
  password: null,
});
</script>

<template>
  <div class="login">
    <img class="login__brand" src="@img/mm-letter.svg" alt="Mastermind" />
    <h2 class="login__title">ACCESO AL SISTEMA</h2>
    <h3 class="login__subtitle">Inicia sesión para empezar a aprender</h3>
    <form @submit.prevent="form.post(resolveUrl('account_loging'))">
      <PillContainer :full-width="true" no-padding>
        <Input
          v-model="form.username"
          type="email"
          placeholder="Email"
          required
          size="medium"
          theme="dark-bold"
          shape="square"
          :class="[{ error: Object.keys(form.errors).length }]"
          high
          full-width
        />
        <span v-if="form.errors.username" class="error">{{ form.errors.username }}</span>
      </PillContainer>
      <PillContainer full-width :class="'login__psw-container'" no-padding>
        <Input
          v-model="form.password"
          required
          type="password"
          placeholder="Contraseña"
          size="medium"
          theme="dark-bold"
          shape="square"
          :class="[{ error: Object.keys(form.errors).length }]"
          high
          full-width
        />
        <Btn
          tag="button"
          type="submit"
          theme="green-bold"
          shape="round"
          :class="['input-submit', { 'input-submit-loading': form.processing }]"
          full-width
          :disabledç="form.processing"
        />
        <span v-if="form.errors.password" class="error">{{ form.errors.password }}</span>
      </PillContainer>

      <PillContainer full-width v-if="form.errors['__all__']" no-padding>
        <Pill shape="square" size="small" :class="'error-message'">
          <div class="pico" />
          {{ form.errors["__all__"] }}
        </Pill>
      </PillContainer>
    </form>
    <PillContainer full-width :class="['login__links']" no-padding>
      <a @click="$emit('recovery')">Recuperar contraseña</a>
      <Link :href="resolveUrl('subscription_show')">¿Sin cuenta? Suscríbete ya</Link>
    </PillContainer>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/settings/vars";

.login {
  .pill-container {
    margin-bottom: 4px;
  }

  &__brand {
    margin: 24px 0;
  }

  &__title {
    margin-bottom: 8px;
  }

  &__subtitle {
    margin-top: 0;
  }

  &__links {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;

    a {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  &__psw-container {
    position: relative;
  }
}

.button--plus {
  margin-top: 16px;
}

.error {
  color: vars.$kernel-violet;
}
</style>
